import React from 'react';
import { findIndex, get } from 'lodash';
import { Box, Skeleton } from '@mui/material';

import Comment from '../Comment/Comment';
import StatusChange from '../StatusChange';
import { Post } from '../../../../Utils/Types/Posts';

interface CommentsListProps {
  comments: any[];
  loading: boolean;
  post: Post;
  parentPost: any;
  postAuthorId: number;
  isNested?: boolean;
  disabled?: boolean;
  refetch?: () => void;
  discussionType?: string;
  censored?: boolean;
}

function CommentsList({
  comments = [],
  loading = false,
  post,
  parentPost,
  postAuthorId,
  isNested,
  disabled,
  refetch,
  discussionType,
  censored = true,
}: CommentsListProps) {
  const lastAdminResponse = findIndex(comments, (comment) => get(comment, 'is_admin'));

  if (lastAdminResponse > -1) {
    comments.splice(lastAdminResponse, 1, {
      ...comments[lastAdminResponse],
      is_admin_response: true,
    });
  }

  if (loading && comments.length === 0) {
    return [1, 2, 3].map((id) => (
      <Box key={id} sx={{ mb: 2 }}>
        <Skeleton variant="rectangular" height={80} width="100%" />
      </Box>
    ));
  }

  return comments.map((comment: any) => {
    return (
      <Box key={comment.id} sx={{ mb: 3 }}>
        {comment.type === 'status_update' ? (
          <StatusChange content={comment.content} createdAt={comment.created_at} />
        ) : (
          <Comment
            comment={comment}
            isNested={isNested}
            post={post}
            parentPost={parentPost}
            authorId={postAuthorId}
            isAdminResponse={comment.is_admin_response}
            disabled={disabled}
            key={comment.id}
            onDestroy={refetch}
            discussionType={discussionType}
            censored={censored}
          />
        )}
      </Box>
    );
  });
}

export default CommentsList;
